import { Link } from "react-router-dom";
import { allWorks } from "@/lib/works";
import { TYPE_LABELS } from "@/types/work";

const PLOTS = allWorks
  .filter((work) => work.featured && work.episodes.length > 0)
  .slice(0, 3);

export default function FeaturedPlots() {
  return (
    <section className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
      <div className="mb-7 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            热门剧情精选
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            精选剧集分集剧情看点，点开章节即可了解这一段发生了什么
          </p>
        </div>
        <span className="flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
          <i className="ri-fire-line"></i>
          编辑推荐
        </span>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {PLOTS.map((work) => (
          <article
            key={work.id}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
          >
            <Link to={`/detail/${work.id}`} className="block cursor-pointer">
              <div className="h-44 w-full overflow-hidden bg-background-200 md:h-48">
                <img
                  src={work.cover}
                  alt={`${work.title} 剧照`}
                  title={`${work.title} 剧情介绍`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
            </Link>
            <div className="flex flex-1 flex-col p-4 md:p-5">
              <div className="flex items-center gap-2">
                <span className="rounded-md bg-primary-50 px-2 py-0.5 text-[11px] font-medium text-primary-600">
                  {TYPE_LABELS[work.type]}
                </span>
                <span className="text-[11px] text-foreground-500">
                  {work.region} · {work.year}
                </span>
                <span className="ml-auto flex items-center gap-1 text-[11px] font-medium text-accent-700">
                  <i className="ri-star-fill"></i>
                  {work.rating.toFixed(1)}
                </span>
              </div>
              <Link to={`/detail/${work.id}`} className="cursor-pointer">
                <h3 className="mt-2.5 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {work.title}
                </h3>
              </Link>
              <p className="clamp-2 mt-1.5 text-xs leading-relaxed text-foreground-600">
                {work.highlight}
              </p>

              <div className="mt-4 border-t border-background-200 pt-3.5">
                <p className="mb-2.5 flex items-center gap-1.5 text-xs font-medium text-foreground-700">
                  <i className="ri-list-check-2 text-primary-500"></i>
                  分集剧情
                </p>
                <div className="flex flex-wrap gap-1.5">
                  {work.episodes.map((episode) => (
                    <Link
                      key={episode.no}
                      to={`/detail/${work.id}`}
                      title={episode.title}
                      className="rounded-md border border-background-300 px-2.5 py-1 text-[11px] text-foreground-600 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-600 cursor-pointer"
                    >
                      第{episode.no}集
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}